<div class="flex gap-6">
  <div class="flex-1">
    <h2 class="mb-2 text-xl font-bold tracking-tight text-gray-900 text-center">Products</h2>

    <ag-grid-angular
      [rowData]="products()"
      [columnDefs]="itemColumnDefs"
      [gridOptions]="itemTableDef"
      [loading]="isLoading()"
    ></ag-grid-angular>
  </div>

  <div class="flex-1">
    <h2 class="mb-2 text-xl font-bold tracking-tight text-gray-900 text-center">Cart</h2>

    <ag-grid-angular
      [rowData]="cart()"
      [columnDefs]="cartColumnDefs"
      [gridOptions]="cartTableDef"
      [loading]="isLoading()"
    ></ag-grid-angular>
  </div>
</div>

<div class="flex gap-6">
  <div class="flex-1"></div>
  <div class="flex-1 flex flex-col items-end p-3">
    <!-- compute cart quantity, price total of all -->
    <p class="mb-2">Total (Tax Exclusive): {{ totalCartValue() | currency: "USD" }}</p>

    <app-pan-button color="success" fill="outline" icon="shopping_cart" (click)="checkout()" matTooltip="Purchase on behalf of customer">
      Checkout
    </app-pan-button>
  </div>
</div>
